import React, { useState, useRef, useEffect, useMemo } from "react";
import { useSelector, useDispatch } from 'react-redux'
import 'react-toastify/dist/ReactToastify.css';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import ReactTooltip from "react-tooltip";
import { Backdrop, Box, Button, Fade, IconButton, InputBase, Modal, Typography, useTheme } from "@mui/material";
import { tokens } from "../theme";
import { BASE_NAME, BRACE_NAME } from "./CantileverPart";
import { updatePickListQuotationParts } from "../features/cart/cartSlice";
import { getAvailableQuantity, splitPickQuantities } from "../common/inventory";
import Parse from 'parse'

const PicklistPart = (props) => {
	const theme = useTheme();
    const dispatch = useDispatch();
    const pickListQuotationParts = useSelector((state) => state.cart.pickListQuotationParts);
	const colors = tokens(theme.palette.mode);
    const part = props.part;
    const picklistDocType = props.picklistDocType;
    const quotationParts = props.quotationParts;
    const setQuotationPartsUpdated = props.setQuotationPartsUpdated;
    const [partQuantity, setPartQuantity] = useState(part.quantity);
    const [partInventoryQuantity, setPartInventoryQuantity] = useState(null);

    const getInventoryQuantity = async (id, className) => {
        if (!id || !className) {
            console.error(`Cannot look up inventory without an ID and class:`, { id, className });
            return 0;
        }
        const query = new Parse.Query(Parse.Object.extend(className));
        query.equalTo("objectId", id);
        const inventoryObj = await query.find();
        if (inventoryObj.length === 0) {
            console.error(`No inventory found for ID: ${id} in class: ${className}`);
            return 0; // Return 0 if no inventory found
        };
        return inventoryObj[0].get("quantity");
    }
    
    // partID is shared by every section the part appears in, so it cannot identify the
    // row being edited on its own - an edit would land on whichever section came first.
    const isRowBeingEdited = (row) =>
        row.section === part.section && (part.id ? row.id === part.id : row.partID === part.partID);

    const handleQuantityChange = (e) => {
        setPartQuantity(e.target.value);
        const quotationPartsCopy = [...pickListQuotationParts];
        const targetIndex = pickListQuotationParts.findIndex(isRowBeingEdited);
        if (targetIndex === -1) {
            console.error('Could not find the picklist row for part:', part);
            return;
        }
        const quantity = parseInt(e.target.value, 10);
        const updatedObj = {...quotationPartsCopy[targetIndex]}
        updatedObj["quantity"] = Number.isFinite(quantity) ? quantity : 0
        quotationPartsCopy[targetIndex] = updatedObj;
        dispatch(updatePickListQuotationParts([...quotationPartsCopy]));
    }

    
    useEffect(() => {
        const fetchQuantity = async () => {
            if (part) {
                const qty = await getInventoryQuantity(part.id, part.className);
                setPartInventoryQuantity(qty);
            }
        };
        fetchQuantity();
    }, [part?.id, part?.className]);

    const availableQuantity = getAvailableQuantity({ ...part, liveInventoryQuantity: partInventoryQuantity });
    // Listed on the internal document for the units the warehouse can pick, and on the
    // external one for the units that still have to be bought in. Whether the row is
    // listed follows the saved order, so a row cannot disappear while it is being typed in.
    const savedSplit = splitPickQuantities(part.quantity, availableQuantity);
    const isListed = (picklistDocType === 'internal' ? savedSplit.fromStock : savedSplit.shortfall) > 0;

    // The caption follows the quantity currently in the box. The internal document prints
    // two side plates per base, so say so here rather than contradict the PDF.
    const editedSplit = splitPickQuantities(partQuantity, availableQuantity);
    const printedQuantity = picklistDocType === 'internal'
        ? (part.name === BASE_NAME && part.duty !== "Light" ? editedSplit.fromStock * 2 : editedSplit.fromStock)
        : editedSplit.shortfall;

	return (
        <Box display='flex' justifyContent='space-between' alignItems='center' mt='0.5em'>
            {isListed && <>
                <Box>
                <Typography>{part?.className === 'CantileverParts' ?
                <Typography>{part?.name} - {" "}{part?.name === BRACE_NAME && part?.layout}{" "}{part?.width} wide -{" "}{part?.height} high -{" "}{part?.depth} deep</Typography> :
                <Typography>{part?.name} {part?.description}</Typography>}</Typography>
                <Typography variant="caption" sx={{ display: 'block', color: colors.greenAccent[400] }}>
                    {editedSplit.fromStock} in stock, {editedSplit.shortfall} to buy - this picklist prints {printedQuantity}
                </Typography>
                </Box>
                    <InputBase
                        data-tip
                        data-for="title"
                        placeholder="Quote Number"
                        className="outlined border rounded px-2 mx-1"
                        name="title"
                        value={partQuantity}
                        onChange={handleQuantityChange}
                        onBlur={() => {}}
                        sx={{ width: "50px" }}
                    />
            </>}
        </Box>
    );
};
export default PicklistPart;